import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import AdminApp from './AdminApp';
import SuperAdminApp from './SuperAdminApp';
import CompanionApp from './CompanionApp';
import GuestApp from './GuestApp';
import TeamsCallback from './views/TeamsCallback';
import { installDebugHelper } from './lib/buildInfo';
import './styles/tokens.css';
import './styles/global.css';

installDebugHelper();

// Welle 9 pre71: Light-Theme als Standard. Der Store-Default ist 'light', aber das
// data-theme-Attribut wird sonst erst bei einer Nutzeraktion gesetzt — hier am Boot,
// damit die hellen Tokens (und color-scheme) sofort für alle Einstiege greifen.
document.documentElement.setAttribute('data-theme', 'light');

// Welle 8c Phase A: Companion-Modus via ?companion=1 (TS-Browser-Bookmark). Eigener
// Top-Level-Branch, damit die normalen Agent-Hintergrund-Hooks nicht laufen.
const params = new URLSearchParams(window.location.search);
const companionMode = params.get('companion') === '1';
// Welle 8d: Gast-/Experten-Modus via ?gast (Magic-Link). Komplett losgelöst von
// Login und Agent-Hooks — der Token steckt im URL-Fragment (#t=…).
const guestMode = params.has('gast');
// Welle 9: Admin-App via ?admin (Mandanten-Administration). Eigener Branch, nutzt den
// bestehenden Login wieder, ist aber von Dashboard/Agent-Hooks entkoppelt.
const adminMode = params.has('admin');
// Welle 9: SUPERADMIN-App via ?superadmin (mandantenübergreifend). Eigener Branch.
const superAdminMode = params.has('superadmin');
// pre142: OAuth-Redirect der Teams-Verknüpfung (Microsoft hängt ?code=…&state=… an).
// Eindeutig an code+state erkennbar → eigener Branch, vor allen anderen.
const teamsCallback = params.has('code') && params.has('state');

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {teamsCallback ? <TeamsCallback /> : guestMode ? <GuestApp /> : superAdminMode ? <SuperAdminApp /> : adminMode ? <AdminApp /> : companionMode ? <CompanionApp /> : <App />}
  </React.StrictMode>
);
